export default function Hero() {
  const stats = [
    { num: "8.7万+", label: "已归档事件" },
    { num: "32万+", label: "整理截图" },
    { num: "12个", label: "内容分类" },
    { num: "3分钟", label: "读懂一件瓜" },
  ];
  const tags = ["聊天记录", "朋友圈", "微博截图", "事件时间线", "全程复盘", "观点对比"];

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* 顶部留白给固定导航 */}
      <div className="h-16" />
      <div className="pointer-events-none absolute -right-40 -top-32 h-96 w-96 rounded-full bg-accent-100/70 blur-3xl" />
      <div className="pointer-events-none absolute -left-32 top-64 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />

      <div className="relative mx-auto grid max-w-content items-center gap-10 px-4 pb-14 pt-10 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        <div>
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-600">
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="absolute h-2 w-2 animate-ping rounded-full bg-primary-500/60" />
              <span className="h-2 w-2 rounded-full bg-primary-500" />
            </span>
            爆料截图 · 持续收录中
          </p>

          <h1 className="font-heading text-4xl font-black leading-[1.15] text-foreground-950 md:text-[3.4rem]">
            吃瓜不迷路，
            <br />
            <span className="relative text-primary-600">
              一张张图看懂来龙去脉
              <span className="absolute -bottom-1 left-0 h-2 w-full rounded-full bg-accent-200" aria-hidden="true" />
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-500 md:text-lg">
            吃瓜图集按「事件」把聊天记录、朋友圈、微博动态、公开评论与官方回应串成一条时间线。
            同一事件的多方说法并排呈现，支持一键对比，省得你满屏翻聊天记录。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#latest"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              浏览最新图集
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-secondary-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
            >
              看事件时间线
            </a>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            <span className="mr-1 text-xs text-foreground-400">常看的类型：</span>
            {tags.map((t) => (
              <a
                key={t}
                href="#latest"
                className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 transition hover:bg-secondary-200"
              >
                {t}
              </a>
            ))}
          </div>
        </div>

        {/* 右侧：图集封面拼贴 */}
        <div className="relative mx-auto w-full max-w-md">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4 pt-8">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20collage%20of%20chat%20screens%20and%20social%20feed%20cards%2C%20warm%20cream%20and%20coral%20editorial%20style%2C%20flat%20illustration%2C%20no%20faces&width=520&height=640&seq=hero-card-1&orientation=portrait"
                alt="聊天记录与截图整理封面拼贴"
                className="w-full rounded-2xl border border-background-200 object-cover"
                width={520}
                height={640}
              />
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20collage%20of%20news%20clippings%20and%20phone%20screens%2C%20terracotta%20and%20cream%20palette%2C%20flat%20magazine%20illustration%2C%20no%20faces&width=520&height=400&seq=hero-card-2&orientation=portrait"
                alt="事件时间线归档图集"
                className="w-full rounded-2xl border border-background-200 object-cover"
                width={520}
                height={400}
              />
            </div>
            <div className="space-y-4">
              <div className="rounded-2xl border border-accent-200 bg-accent-50 p-4 text-accent-900">
                <p className="text-xs text-accent-700">今日新增</p>
                <p className="mt-1 font-heading text-2xl font-bold">+128 套图集</p>
                <p className="mt-1 text-xs leading-relaxed text-accent-700/80">时间线、回应与评论区观点均已归档</p>
              </div>
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20editorial%20art%20of%20a%20timeline%20with%20dots%20and%20lines%20in%20warm%20amber%20tones%2C%20flat%20magazine%20illustration%2C%20no%20faces&width=520&height=640&seq=hero-card-3&orientation=portrait"
                alt="事件时间线整理图示"
                className="w-full rounded-2xl border border-background-200 object-cover"
                width={520}
                height={640}
              />
            </div>
          </div>
          <div className="absolute -bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800">
            <i className="ri-fire-fill text-primary-500" />
            一件瓜 · 一个时间线
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-content px-4 pb-12 md:px-6">
        <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-background-200 bg-background-200 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-background-50 px-5 py-5 text-center md:py-6">
              <dt className="order-2 mt-1 text-xs text-foreground-400">{s.label}</dt>
              <dd className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">{s.num}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}